import React from 'react';
import isEmpty from 'lodash/isEmpty';

import * as Typo from 'core/styles/Typography';
import { ICONS, Icon } from 'core/components/Icon';
import Image from 'core/sitecore/jss-proxy-components/JssImage';
import { JssImageType, JssTextType } from 'core/utils/sitecore-utils';
import ExperienceEditorContent from 'core/sitecore/experience-editor/ExperienceEditorContent';

import * as S from './BPAYInfo.style';

interface IProps {
	bpayIcon?: JssImageType;
	billerCode: string | number | undefined;
	referenceNumber: string | number | undefined;
	billerCodeLabel?: JssTextType;
	referenceNumberLabel?: JssTextType;
	dataTarget?: string;
	isDashboardModule?: boolean;
}

const BPAYInfo = ({
	bpayIcon,
	billerCode,
	referenceNumber,
	billerCodeLabel = { value: 'Biller code:' },
	referenceNumberLabel = { value: 'Reference:' },
	dataTarget = 'BPAY-info',
	isDashboardModule = false,
}: IProps) => {
	let icon = (
		<Icon name={ICONS.LOGO_BPAY} data-target-id={`${dataTarget}--icon`} />
	);
	if (!isEmpty(bpayIcon) && !isEmpty(bpayIcon?.value)) {
		icon = <Image field={bpayIcon} data-target-id={`${dataTarget}--icon`} />;
	}

	return (
		<>
			<S.BPAYWrapper
				data-target-id={`${dataTarget}`}
				isDashboardModule={isDashboardModule}
			>
				{icon}
				{isDashboardModule ? (
					<S.BPAYInfo>
						<div>
							<Typo.Body
								margin="0 0 12px"
								data-target-id={`${dataTarget}--biller-code`}
							>
								<strong>{billerCodeLabel.value}</strong> <br />
								{billerCode}
							</Typo.Body>
						</div>
						<div>
							<Typo.Body
								margin="0"
								data-target-id={`${dataTarget}--reference-number`}
							>
								<strong>{referenceNumberLabel.value}</strong> <br />
								{referenceNumber}
							</Typo.Body>
						</div>
					</S.BPAYInfo>
				) : (
					<S.BPAYInfo>
						<div>
							<Typo.Body
								margin="0"
								data-target-id={`${dataTarget}--biller-code`}
							>
								{billerCodeLabel.value} <strong>{billerCode}</strong>
							</Typo.Body>
						</div>
						<div>
							<Typo.Body
								margin="0"
								data-target-id={`${dataTarget}--reference-number`}
							>
								{referenceNumberLabel.value} <strong>{referenceNumber}</strong>
							</Typo.Body>
						</div>
					</S.BPAYInfo>
				)}
			</S.BPAYWrapper>
			<ExperienceEditorContent
				title="BPAY detail fields"
				margin="20px 0 0"
				elementDefinitions={[
					{ name: 'Biller code label', jss: billerCodeLabel },
					{ name: 'Reference number label', jss: referenceNumberLabel },
				]}
			/>
		</>
	);
};

export default BPAYInfo;
